// extracted by mini-css-extract-plugin
export default {"number":"FlightReportAll_number__UhRRP"};